import QUADRATIC_EQUATION_ZEROES from "./Questions/quadratic_equation";
import ROOT_TYPE from "./Questions/quadratic_root_types";

export default function QUADRATIC_EQUATIONS() {
  return (
    <section id="quadratic_equations" className="grid gap-16">
      <QUADRATIC_EQUATION_ZEROES />
      <ROOT_TYPE />
    </section>
  );
}
